import { lazy } from 'react';
import Loadable from 'components/Loadable';

const PageNotFoundPage = Loadable(lazy(() => import('../sections/not-found/PageNotFoundPage')));

// ==============================|| CHART & MAP ROUTING ||============================== //

const PageNotFoundRoutes = {
  path: '*',
  element:<PageNotFoundPage/>
};

export default PageNotFoundRoutes;
